
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import auth from './auth';
import common from './common';
import ddny from './ddny';
import diamonds from './diamonds';
import header from './header';
import jewelry from './jewelry';
import leads from './leads';
import login from './login';
import messages from './messages';
import stores from './stores';
import users from './users';
import watches from './watches';



const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  auth,
  common,
  ddny,
  diamonds,
  header,
  jewelry,
  leads,
  login,
  messages,
  stores,
  users,
  watches,
})
export default createRootReducer